import React, { createContext, useContext, useReducer } from 'react';


//prepares the datalayer
export const StateContext = createContext();


//Wrap our app and provide DataLayer
export const StateProvider = ({ reducer, initialState, children }) => (
    <StateContext.Provider value={useReducer(reducer, initialState)}>
        {children}
    </StateContext.Provider>
);

//Pull infoemation from DataLayer
export const useStateValue = () => useContext(StateContext); 